import { useRef } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import DynamicBrandLanding from './_components/DynamicBrandLanding';
import DynamicBrandDashboard from './_components/DynamicBrandDashboard';

import { createBrandStore } from './store';
import { BrandStoreProvider } from './context';

import { queryClient } from '../../../application';

export default function DynamicBrandIndex(props) {
  const { dynamic_brand, site_logo, site_logo_secondary, site_favicon, site_font, site_font_secondary, site_font_tertiary, site_og_image } = props;

  const brandStoreRef = useRef(null);

  if (!brandStoreRef.current) {
    brandStoreRef.current = createBrandStore(
      dynamic_brand,
      site_logo,
      site_logo_secondary,
      site_favicon,
      site_font,
      site_font_secondary,
      site_font_tertiary,
      site_og_image,
    );
  }

  const brandStore = brandStoreRef.current;

  return (
    <QueryClientProvider client={queryClient}>
      <div className="db-brand-kit-container">
        <BrandStoreProvider brandStore={brandStore}>
          {dynamic_brand ? <DynamicBrandDashboard {...props} /> : <DynamicBrandLanding {...props} />}
        </BrandStoreProvider>
      </div>
    </QueryClientProvider>
  );
}
